module.exports = __webpack_public_path__ + "static/media/bioIcon.12896349.svg";